const MAP_DATA_FAILURES = new Set([
  "DuplicatePlotIds",
  "UnknownPlotIds",
  "MissingPrediction",
  "EmptyResultSet",
]);

const RESUBMITTABLE_FAILURES = new Set([
  "SourceResultSetNotFound",
  "NoFieldArea",
  "CalibrationNotStarted",
]);

export function failureMessageKey(errorCode: string | undefined): string {
  if (errorCode && MAP_DATA_FAILURES.has(errorCode)) {
    return "message.calibration.failed.map_data";
  }
  if (errorCode === "ZeroVarianceSamples") {
    return "message.calibration.failed.counts_too_similar";
  }
  if (errorCode && RESUBMITTABLE_FAILURES.has(errorCode)) {
    return "message.calibration.failed.run_again";
  }
  return "message.calibration.failed.unexpected";
}
